export default __webpack_public_path__ + "static/media/Dell-XPS-13-laptop.3240f004.jpg";